import { sendClickLog } from '../../utils/sendClickLog';
import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';

import styled from '@emotion/styled';
import { globalVariables } from '../../../shared/designSystem/constants';
import { useEnvContext } from '../../../modules/EnvProvider';
import { getAuthLink } from '../../utils/getAuthLink';

export default function PolicyList() {
  const { targetEnv } = useEnvContext();

  const policyItems = [
    {
      title: '이용 약관',
      link: getAuthLink('/terms/policyAgreement', targetEnv),
      bold: false,
    },
    {
      title: '개인정보 처리방침',
      link: getAuthLink('/terms/common/privacy', targetEnv),
      bold: true,
    },
    {
      title: '취소 및 환불 정책',
      link: getAuthLink('/terms/common/cancel', targetEnv),
      bold: false,
    },
    {
      title: '개발자 센터',
      link: 'https://docs.myrealtrip.com/#/api/intro',
      bold: false,
      external: true,
    },
  ];
  const handleClick =
    ({ title, targetUrl }: { title: string; targetUrl: string }) =>
    () => {
      sendClickLog({
        eventName: 'footer',
        screenName: WeblogScreenName.COMMON,
        pageCategory: WeblogPageCategory.COMMON,
        menuTitle: title,
        targetUrl: targetUrl,
      });
    };

  return (
    <Container>
      {policyItems.map(({ title, link, bold, external }) => (
        <PolicyItem key={title}>
          <Link
            href={link}
            bold={bold}
            onClick={handleClick({ title, targetUrl: link })}
            {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
          >
            {title}
          </Link>
        </PolicyItem>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
`;

const PolicyItem = styled.div`
  display: flex;
  align-items: center;
  height: 44px;

  &:not(:first-of-type) {
    margin-left: 20px;
  }
`;

const Link = styled.a<{ bold?: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 6px;
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? 700 : 400)};
  color: ${globalVariables.gray_600};
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    color: ${globalVariables.blue_500};
    background-color: ${globalVariables.blue_50};
  }
`;
